<template>
  <b-overlay :show="isloading" spinner-variant="primary" variant="transparent">
    <b-card-actions :badge="badge" :collapsed="collapsed" :title="title" no-body :sub-title="subtitle" action-collapse>
      <b-card-header>
        <div></div>
        <div>
          <slot name="button"></slot>
        </div>
      </b-card-header>
      <b-card-body :key="cKey">
        <slot name="body"></slot>
      </b-card-body>
    </b-card-actions>
  </b-overlay>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {BCardHeader,BCardBody,BOverlay} from 'bootstrap-vue'
export default {
  name:'MyCard',
  props:{
    title:{
      type: String,
      default: ''
    },
    isloading:{
      type: Boolean,
      default: false
    },
    collapsed:{
      type: Boolean,
      default: false
    },
    subtitle:{
      type: String
    },
    badge:{
      type: [Number,String]
    }
  },
  data(){
    return {
      cKey: 0
    }
  },
  components:{
    BCardActions,
    BCardHeader,
    BCardBody,
    BOverlay
  },
  methods:{
    refreshCard(){
      this.cKey++
    }
  }
}
</script>

<style>

</style>